module.exports = __webpack_public_path__ + "assets/img/warrior-name-f119ee43.png";